/**
 * Define methods that can mixin'ed to a datasource to improve performance when many changes are made.
 * This is useful for performance improvements when check all and grouping are used on a grid.
 */
export default {
    _process: function(data, e) {
        if (e && e.action == "itemchange" && !this._fieldInUse(e.field)) {
            this.trigger("change", e);
        } else {
            return this.super.fn._process.apply(this, arguments);
        }
    },

    _fieldInUse: function(field) {
        var check = function(items) {
            if (items && items.filters) {
                return check(items.filters);
            } else if (items) {
                for (var i = 0; i < items.length; i++) {
                    if (field == items[i].field) {
                        return true;
                    }
                }
            }
            return false;
        };
        return check(this.filter()) || check(this.sort()) || check(this.group()) || check(this.aggregate());
    }
};